module.exports = __webpack_public_path__ + "static/media/0.736e9503.jpg";